module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('section', {
    attrs: {
      "id": "article"
    }
  }, [_c('cover-image', {
    attrs: {
      "src": (_vm.article.shouldShowCover && _vm.article.image) ? _vm.article.image : '/static/placeholders/placeholder-logo.jpg',
      "title": '',
      "description": '',
      "type": 'medium'
    }
  }), _vm._v(" "), _c('article', {
    staticClass: "article container",
    class: _vm.article.image == null ? 'no-image' : ''
  }, [(_vm.article.author) ? _c('h4', {
    staticClass: "author text-center"
  }, [_vm._v(_vm._s(_vm.article.author.name + ' ' + _vm.article.author.surname))]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title row text-center"
  }, [_vm._v(_vm._s(_vm.translation.title))]), _vm._v(" "), _c('p', {
    staticClass: "date row text-center"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.article.publishDate, 'en')))]), _vm._v(" "), _c('div', {
    staticClass: "article-options"
  }, [_c('i', {
    staticClass: "fa fa-print article-option",
    on: {
      "click": _vm.print
    }
  }), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": 'http://mons.rs' + this.$route.path,
      "title": _vm.translation.title,
      "description": _vm.translation.description,
      "hashtags": 'mons'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('network', {
            staticClass: "article-option",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          })]), _vm._v(" "), _c('network', {
            staticClass: "article-option",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content row",
    attrs: {
      "name": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translation.content)
    }
  }), _vm._v(" "), (_vm.graphExists) ? _c('graph-view', {
    attrs: {
      "chartData": _vm.chartData,
      "chartOptions": _vm.chartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mapExists) ? _c('maps-view', {
    attrs: {
      "chartData": _vm.chartData,
      "chartOptions": _vm.chartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.article && (_vm.article.previousArticle || _vm.article.nextArticle)) ? _c('div', {
    staticClass: "row"
  }, [(_vm.hasPreviousArticle) ? _c('div', {
    staticClass: "button article-nav col-4"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.previousArticle
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left"
  }), _vm._v("\n          " + _vm._s(_vm.$t('button.previous_article')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasNextArticle) ? _c('div', {
    staticClass: "button article-nav col-4 text-right",
    class: _vm.hasPreviousArticle ? 'push-4' : 'push-8'
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.nextArticle
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.next_article')) + "\n          "), _c('i', {
    staticClass: "fa fa-caret-right"
  })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "lightbox"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "modal-image",
    attrs: {
      "src": "",
      "alt": "",
      "id": "lightbox-image"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c026c432"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ArticleView.vue
// module id = 515
// module chunks = 1